<template>
    <div class="container-fluid" id="dvcrud">
        <div class="row">
            <consultaprodutos v-bind:idtabela="vidtabela" v-bind:showprtabela="vshowprtabela" v-bind:filtrotipo="tipopropesquisa"></consultaprodutos>
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cbopfiltro">Filtrar:</label>
                                <select name="cbopfiltro" class="form-control form-control-sm" id="cbopfiltro" v-model="pfiltro" @change="mtdlimpar_listagem()">
                                    <option value="0">Código</option>
                                    <option value="1">Descrição</option>
                                </select>
                            </div>
                            <div class="col-sm-8 col-md-6 col-lg-6">
                                <label for="edconteudopesq">Conteúdo da pesquisa:</label>
                                <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pconteudo" @keyup="mtdlimpar_listagem()">
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lstformulas"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="id_f" slot-scope="item">
                                        {{ item.row.id }}
                                    </template>
                                    <template slot="opcoes" slot-scope="item">
                                        <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalterar(item.row)"><i class="fa fa-edit"></i></button>
                                        <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluir(item.row)"><i class="fa fa-trash"></i></button>
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstformulas.length}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-8 col-sm-8 col-md-10 col-lg-10" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Novo</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edid">Código:</label>
                                <input type="text" class="form-control form-control-sm" id="edid" v-model="vid"
                                       maxlength="20" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-10 col-lg-10">
                                <label for="eddescricao">*Descrição:</label>
                                <input type="text" v-model="vdescricao" v-bind:disabled="ativadesativa"
                                       class="form-control form-control-sm" id="eddescricao" maxlength="50">
                            </div>
                            <div class="col-md-12" style="margin-top: 15px;">
                                <div class="card">
                                    <div class="card-header card-in text-center" style="padding: 5px;">ITENS DA FÓRMULA</div>
                                    <div class="card-body">
                                        <div v-show="parseInt(opcrud) < 3" class="row">
                                            <div class="col-sm-12 col-md-3 col-lg-2">
                                                <label for="edidproduto">Produto:</label>
                                                <div class="input-group" style="z-index: 1;">
                                                    <input type="text" class="form-control form-control-sm" id="edidproduto" v-model="vcoddig" maxlength="20" v-on:blur="mtdlocalizarproduto(vcoddig)" v-on:keyup.13="mtdlocalizarproduto(vcoddig)" style="text-transform: uppercase;">
                                                    <div class="input-group-append">
                                                        <a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdconsultarproduto()"><i class="fa fa-search" style="padding-top: 3px;"></i></a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-md-7 col-lg-6">
                                                <label for="eddescricaoproduto">Descrição do produto:</label>
                                                <input type="text" class="form-control form-control-sm" id="eddescricaoproduto" v-model="vdescricaoproduto" maxlength="100" style="font-weight: bold;" disabled>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edqtditem">Qtd/Perc:</label>
                                                <money type="text" class="form-control form-control-sm" id="edqtditem" v-model="vqtditem" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
                                            </div>
                                            <div class="col-md-2">
                                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdincluiritem()" style="margin-top: 20px;"><i class="fa fa-plus"></i> Incluir</button>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12" style="margin-top: 10px;">
                                                <vue-bootstrap4-table ref="reflstitens"
                                                        :rows="lstitens"
                                                        :columns="columnsitens"
                                                        :config="configitens"
                                                        :classes="classes">
                                                    <template slot="empty-results">
                                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                                    </template>
                                                    <!-- ícones de ordenação da table -->
                                                    <template slot="sort-asc-icon">
                                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                                    </template>
                                                    <template slot="sort-desc-icon">
                                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                                    </template>
                                                    <template slot="no-sort-icon">
                                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                                    </template>                                    
                                                    <!--  -->                                                    
                                                    <template slot="opcoes" slot-scope="item">
                                                        <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluiritem(item.row)" v-bind:disabled="parseInt(opcrud) === 3"><i class="fa fa-trash"></i></button>
                                                    </template>
                                                    <template slot="slot_codigo" slot-scope="item">
                                                        <span style="font-weight: 600;">{{ item.row.coddig }}</span>
                                                    </template>
                                                    <!-- <template slot="slot_qtditem" slot-scope="item">
                                                        <span @click.prevent="mtdalterarqtd(item.row, false, 1)"><i class="op-qtd op-qtd-ret fa fa-minus-circle"></i></span>
                                                        <span style="font-weight: 600;">{{ item.row.qtditem }}</span>
                                                        <span @click.prevent="mtdalterarqtd(item.row, true, 1)"><i class="op-qtd op-qtd-acres fa fa-plus-circle"></i></span>
                                                    </template>                                                     -->
                                                    <template slot="slot_qtditem" slot-scope="item">[=]
                                                        <span @click.prevent="mtdalterarqtd(item.row, false, 1)"><i  class="op-qtd op-qtd-ret fa fa-minus-circle"></i></span>
                                                        <span @dblclick="mtdinserirqtd(item.row)" style="font-weight: 600; cursor: pointer;" title="Dê dois cliques para alterar a quantidade">{{ mtdformatavalordecimal(item.row.qtditem , 3)}}</span>
                                                        <span @click.prevent="mtdalterarqtd(item.row, true, 1)"><i  class="op-qtd op-qtd-acres fa fa-plus-circle"></i></span>        
                                                    </template>
                                                </vue-bootstrap4-table>
                                            </div>                                                                                        
                                        </div>
                                    </div>
                                </div>        
                            </div>                            
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Alterar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Excluir
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>  

        <!--Luiz Trindade - Modal para alterar o valor da quantidade de itens que irão para as fórmulas-->
        <div class="modal fade" id="mdqtditem">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content">                                          
                    
                    <div class="modal-body">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-12">
                                    <label for="edqtditemproditem">Quantidade:</label>
                                    <money type="text" class="form-control form-control-sm" id="edqtditemproditem" v-model="vqtdalteritem" data-bv-group=".group" maxlength="20" style="text-align:right;" v-bind:disabled="ativadesativa"></money>
                                </div>
                            </div>
                        </div>
                    </div>                                            
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdpreparaqtd()" style="width: 100px;"><i class="fa fa-check"></i> Ok</button>                        
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-close"></i> Cancelar</button>
                    </div>                          
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import ConsultarProdutos from '../components/cmpconsultarprodutos.vue'
    import util from '../utilitarios/util.js'

    export default {
        name: 'cadformulas',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb'        : BreadCrumb,
            'consultaprodutos'  : ConsultarProdutos
        },
        data: function() {
            return {
                lstformulas  : [],
                pfiltro      : 1,
                pconteudo    : '',
                pqtdregistros: 10,
                pqtd_paginas : 1,
                pagina_atual : 1,
                pqtd_total_registros: 0,

                //variáveis para a consulta de produtos
                vshowprtabela		: false,
                vidtabela           : null,
                tipopropesquisa     : '1, 2',

                //variáveis do crud
                opcrud              :  0,
                vid                 : '',
                vdescricao          : '',
                lstitens            : [],

                //alteração da quantidade
                vqtdalteritem       : 0,
                vindiceitemalt      : 0,

                //variaveis dos itens da formula
                lstitens            : [],
                vitem               : 0,
                vcoddig             : '',
                vidproduto			: '',
                vdescricaoproduto 	: '',
                vundproduto			: '',
                vqtditem            : 1,
                vfracionado			: '',

                //variável para habilitação dos campos
                ativadesativa       : true,

                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'FÓRMULAS',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "Código",
                        name: "id",
                        sort: true,
                        slot_name: "id_f",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Descrição",
                        name: "descricao",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    }
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                },
                columnsitens: [
                    {
                        label: '',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes-item",
                        sort: false
                    },
                    {
                        label: "Item",
                        name: "item",
                        sort: true,
                        slot_name: "slot_item",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Código",
                        name: "coddig",
                        sort: true,
                        slot_name: "slot_codigo",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Descrição",
                        name: "descproduto",
                        sort: true,
                        slot_name: "slot_descpro",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                    },
                    {
                        label: "Qtd/Perc",
                        name: "qtditem",
                        sort: true,
                        slot_name: "slot_qtditem",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-qtd-item",
                    },
                    {
                        label: "Und",
                        name: "unditem",
                        sort: true,
                        slot_name: "slot_unditem",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-und-item",
                    }
                ],
                configitens: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    checkbox_rows: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                }
            }
        },
        methods:{
            mtdformatavalordecimal(valor, digitos){
                return util.formatavalordecimais(valor, digitos);
            },
            mtdfiltropesquisa(){
                let rfiltro = '';
                if (parseInt(this.pfiltro) === 0){
                    rfiltro = this.pconteudo === '' ? '' : ' and id='+this.pconteudo;
                }else{
                    rfiltro = this.pconteudo === '' ? '' : ' and upper(descricao) like upper("'+this.pconteudo+'%")';
                }
                return rfiltro;
            },
            mtdexecutapesquisa(){
                var vself           = this;
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadformulas.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregaformulas(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
            mtdcarregaformulas(ipagina){
                var vself       = this;
                let loader      = this.$loading.show();
                let filtro      = vself.mtdfiltropesquisa();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadformulas.php');
                retorno.then(function (response) {
                    vself.lstformulas = response.data;
                    loader.hide();
                }).catch(function (response) {
                    vself.lstformulas = [];
                    loader.hide();
                });
            },
            resetarDados() {
                util.toTop();

                this.vid                = '';
                this.vdescricao         = '';

                this.lstitens           = [];
                this.vitem              = 0;
                this.vidproduto			= '';
                this.vcoddig            = '';
                this.vdescricaoproduto 	= '';
                this.vundproduto		= '';
                this.vqtditem           = 1;
                this.vfracionado		= '';                 
            },
            mtddefault(){
                $('#pnlista').hide();
                this.resetarDados();
                $('#pncadastro').fadeIn(700);
                this.$nextTick(function () {
                    if (parseInt(this.opcrud) < 3) {
                        $('#eddescricao').focus();
                    } else {
                        $('#btgravar').focus();
                    }
                });
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;
                $('.nav-tabs a[href="#dvperfil"]').tab('show');
                vself.mtddefault();
            },
            mtdnovo(){
                if (!util.opcaousuario('001Z.120Z.010Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO DE FÓRMULA';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(1);
                }
            },
            mtdcancelaredicao(){
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdlimpar_listagem() {
                this.lstformulas = [];
                this.pagina_atual = 1;
                this.filtro = '';
                this.pqtd_total_registros = 0;
                this.pqtd_paginas = 0;
            },
            mtdgravar(){
                let vself = this;
                if (parseInt(vself.opcrud) < 3) {
                    if (parseInt(vself.vtodasfiliais) === 0) {
                    }
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdregistro();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdlocalizaregistro(id){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and id='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadformulas.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.mtdigualarcampos(response.data[0]);
                    if (parseInt(vself.opcrud) < 3){
                        $('#eddescricao').focus();
                    }else{
                        $('#btgravar').focus();
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdalterar(item){
                if (!util.opcaousuario('001Z.120Z.020Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'ALTERAÇÃO DE FÓRMULA';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(2);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdexcluir(item){
                if (!util.opcaousuario('001Z.120Z.030Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'EXCLUSÃO DE FÓRMULA';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = true;
                    this.mtdpreparacrud(3);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdigualarcampos(registro){
                this.vid                = registro.id;
                this.vdescricao         = registro.descricao;
                this.lstitens           = registro.itens;
                this.vitem              = this.lstitens[this.lstitens.length - 1].item;

            },
            mtdregistro(){
                let vself  = this;
                let loader = vself.$loading.show();
                let registrocrud = {
                    'id'                : this.vid,
                    'descricao'         : this.vdescricao,
                    'itens'             : this.lstitens
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacrud'},
                    {parametro: 'opcrud',       valor : vself.opcrud},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : parseInt(this.opcrud) === 1 ? '001Z.120Z.010Z' : parseInt(this.opcrud) === 2 ? '001Z.120Z.020Z' : '001Z.120Z.030Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadformulas.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        vself.pfiltro       = 0;
                        vself.pconteudo     = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                        vself.pqtd_paginas  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarregaformulas(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdlocalizarproduto(coddig){
				if (coddig !== '' && coddig !== null){
					var vself       = this;
					let loader      = vself.$loading.show();
					let parametros  = [
						{parametro: 'op',               valor : 'listagem'},
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',           valor : ' and p.tipo in (1, 2)'},
						{parametro: 'coddig',           valor : coddig},
						{parametro: 'limit',            valor : 1},
						{parametro: 'offset',           valor : 0},
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
					retorno.then(function (response) {
						loader.hide();						
						if (response.data.length > 0){
							let produto = response.data[0];							
							vself.vidproduto			= produto.id;
							vself.vdescricaoproduto 	= produto.descricao;
							vself.vundproduto			= produto.und;
                            vself.vfracionado			= produto.fracionado;

                            if (vself.lancarauto){
                                let indiceitem = util.getArrayIndexForKey(vself.lstitens, 'idproduto', vself.vidproduto);

                                vself.vitem++;                         

                                let itemtmp = {
                                    idproduto		    : vself.vidproduto,
                                    descproduto		    : vself.vdescricaoproduto,
                                    coddig			    : vself.vcoddig,
                                    item			    : vself.vitem,
                                    qtditem			    : vself.vqtditem,
                                    unditem			    : vself.vundproduto
                                };

                                if (parseInt(vself.vfracionado) === 0){
                                    if (!Number.isInteger(vself.vqtditem)){
                                        vself.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
                                        $('#edqtditem').focus();
                                        return;
                                    }
                                }                                                

                                if (indiceitem !== -1){
                                    itemtmp.item = indiceitem;                                   
                                    vself.mtdalterarqtd(itemtmp, true, itemtmp.qtditem);								
                                }else{
                                    vself.mtdlancaitem(itemtmp);
                                }
                                setTimeout(() => {
                                    vself.vidproduto          = '';
                                    vself.vdescricaoproduto   = '';
                                    vself.vcoddig             = '';
                                    vself.vqtditem            = 1;                                    
                                    $('#edidproduto').focus();                                                                                                                      
                                }, 200);                                 
                            }else{
                                vself.$nextTick(function () {
                                    $('#edqtditem').focus();
                                });
                            }
						}else{
							vself.$toastr.w('Código informado não cadastrado no sistema!', 'Atenção!');
							vself.vidproduto			= '';
							vself.vdescricaoproduto 	= '';
							vself.vundproduto			= '';
                            vself.vfracionado			= '';
							$('#edidproduto').focus();
						}
					}).catch(function (response) {
						loader.hide();
					});
				}else{
                    vself.vidproduto			= '';
                    vself.vdescricaoproduto 	= '';
                    vself.vundproduto			= '';
                    vself.vfracionado			= '';
				}
            },        
            mtdconsultarproduto(){
				if (parseInt(this.opcrud) < 3){
					let payload = {
						abrirtela    : true			
					};
					this.$store.commit('CONSULTA_PRODUTO_CHANGE',payload);
					let payloadx = {
						idproduto    : null			
					};
					this.$store.commit('PRODUTO_RETORNO_CHANGE',payloadx);                
				}
			},
            mtdincluiritem(){
                let vself = this;
                if (vself.vcoddig === ''){                    
                    vself.$toastr.w('Código do produto deve ser informado!', 'Informação!');
                    $('#edidproduto').focus();
                    return;
                }
                if (parseFloat(vself.vqtditem) <= 0){                    
                    vself.$toastr.w('Quantidade inválida!', 'Informação!');
                    $('#edqtditem').focus();
                    return;
                }                
                if (parseInt(vself.vfracionado) === 0){
                    if (!Number.isInteger(vself.vqtditem)){
						vself.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
						$('#edqtditem').focus();
                        return;
                    }
                }

                let indiceitem = util.getArrayIndexForKey(vself.lstitens, 'idproduto', vself.vidproduto);
                vself.vitem++;

                let itemtmp = {
                    idproduto		    : vself.vidproduto,
                    descproduto		    : vself.vdescricaoproduto,
                    coddig			    : vself.vcoddig,
                    item			    : vself.vitem,
                    qtditem			    : vself.vqtditem,
                    unditem			    : vself.vundproduto
                };                
                if (indiceitem !== -1){
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Produto já lançado na conferência. Deseja adicionar a quantidade?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'dark',
                        typeAnimated: true,
                        buttons: {
                            sim: {
                                text: '<u>S</u>im',
                                keys: ['s', 'S'],
                                btnClass: 'btn-blue',
                                action: function () {
                                    $('.btn-blue').prop('disabled', true); 
                                    itemtmp.item = indiceitem;                                   
                                    vself.mtdalterarqtd(itemtmp, true, itemtmp.qtditem);

                                    vself.vidproduto          = '';
                                    vself.vdescricaoproduto   = '';
                                    vself.vcoddig             = '';
                                    vself.vqtditem            = 1;
                                    setTimeout(() => {
                                        $('#edidproduto').focus();                                                                                                                      
                                    }, 500);                                  
                                },
                            },
                            nao: {
                                text: '<u>N</u>ão',
                                keys: ['n', 'N'],
                                action: function () {                                
                                    vself.vidproduto          = '';
                                    vself.vdescricaoproduto   = '';
                                    vself.vcoddig             = '';
                                    vself.vqtditem            = 1;                                             
                                    setTimeout(() => {
                                        $('#edidproduto').focus();                                                                                                                      
                                    }, 500);
                                    
                                }
                            }
                        }
                    });                    
                }else{
                    vself.mtdlancaitem(itemtmp);
                }                                
            },            
            mtdlancaitem(itemtmp){
                let vself = this;
                vself.lstitens.push(itemtmp);    
                vself.vidproduto          = '';
                vself.vdescricaoproduto   = '';
                vself.vundproduto         = '';  
                vself.vcoddig             = '';
                vself.vqtditem            = 1;
                $('#edidproduto').focus();                
            },
            mtdexcluiritem(item){
                let indiceitem 		= util.getArrayIndexForKey(this.lstitens, 'item', item.item);

                this.lstitens.splice(indiceitem, 1);                
            },
            mtdalterarqtd(item, aumentar, qtd){
                if (parseInt(this.opcrud) < 3){
                    let indiceitem 		= util.getArrayIndexForKey(this.lstitens, 'idproduto', item.idproduto);                
                    if (aumentar) {
                        this.lstitens[indiceitem].qtditem+=parseFloat(qtd);
                    }else{
                        if (parseFloat(this.lstitens[indiceitem].qtditem) > 1){
                            this.lstitens[indiceitem].qtditem-=parseFloat(qtd);
                        }else{
                            return;
                        }
                    }    
                }
            },

            //Luiz Trindade - Métodos de caddesossa.vue para alterar a quantidade de itens
            mtdinserirqtd(item){
                if (parseInt(this.opcrud) < 3){
                    this.vqtdalteritem  = 0;
                    this.vindiceitemalt = util.getArrayIndexForKey(this.lstitens, 'idproduto', item.idproduto);                
                    this.vqtdalteritem  = parseFloat(this.lstitens[this.vindiceitemalt].qtditem)  
                    $('#mdqtditem').modal('show');
                }
            },

            mtdpreparaqtd(){
                //Luiz Trindade - Método prepara quandtidade                
                let vself = this;
                if (parseInt(vself.lstitens[vself.vindiceitemalt].fracionado) === 0){
                    // console.log("O produto não é fracionado");

                    //Se o valor sem casas decimais for diferente que o valor informado, impede o fluxo de continuar
                    if (Math.floor(this.vqtdalteritem) !== this.vqtdalteritem){
                        this.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
                        $('#edqtditem').focus();
                        return;   
                    }
                }

                this.lstitens[this.vindiceitemalt].qtditem    = parseFloat(this.vqtdalteritem); 
                this.lstitens[this.vindiceitemalt].totalcusto = util.arredondaValores(parseFloat(this.lstitens[this.vindiceitemalt].qtditem) * parseFloat(this.lstitens[this.vindiceitemalt].prcusto), 3, 'round');                 
                //this.vtotalcusto    = parseFloat(this.vtotalcusto) + parseFloat(parseFloat(this.vqtdalteritem) * parseFloat(this.lstitens[this.vindiceitemalt].prcusto));               
                this.mtdgeratotalcusto();
                
                this.vindiceitemalt = 0;
                this.vqtdalteritem  = 0;
                $('#mdqtditem').modal('hide');
            },

            mtdgeratotalcusto(){
                this.vtotalcusto = 0;
                for (let index = 0; index < this.lstitens.length; index++) {
                    this.vtotalcusto += this.lstitens[index].totalcusto 
                }
            },


        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (util.opcaousuario('001Z.120Z', vself.$store.state.perfilusuario)) {
                        $('#pnlista').fadeIn(700);
                        vself.mtdexecutapesquisa();
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            }
        },
        computed:{
            validou() {
                return this.vdescricao === '' ;
            },
            idprodutoretorno(){
                return this.$store.state.produtoretornoconsulta.idproduto;
            },
        },
        watch:{
            pagina_atual(val){
                this.mtdcarregaformulas(val);
            },
            idprodutoretorno(val){
                if (val !== null || val !== ''){
					this.vcoddig = val;
					this.mtdlocalizarproduto(this.vcoddig);					
                }
			}
        }
    }
</script>
<style>
    .def-col-cod{
        width: 80px !important;
    }
    #btclonarperfilusuario{
        cursor: pointer;
        font-weight: bold;
        font-size: 18px;
        position: relative;
        float: right;
        top: 5px;
        transition: .35s;
    }

</style>